import React from "react";
import { ResponsivePie } from "@nivo/pie";
import { ResponsiveBar } from "@nivo/bar";
import StatCard from "../../atoms/StatCard";
import { PropagateLoader } from "react-spinners";

const EmpresaListStats = ({ data = [], loading }) => {
    if (loading) {
        return (
            <div className="w-full flex justify-center items-center">
                <PropagateLoader color="red" />
            </div>
        );
    }

    const totalNaturales = data.filter(item => item.type === "NaturalPerson").length;
    const totalMorales = data.filter(item => item.type === "LegalEntitie").length;
    const totalEmpresas = totalNaturales + totalMorales;
    const porcentajeNaturales = totalEmpresas ? ((totalNaturales / totalEmpresas) * 100).toFixed(2) : 0;
    const porcentajeMorales = totalEmpresas ? ((totalMorales / totalEmpresas) * 100).toFixed(2) : 0;
    const empresasConDeuda = data.filter(item => item.balance < 0);

    const pieData = [
        {
            id: "Personas físicas",
            label: "Personas físicas",
            value: totalNaturales,
            color: "#e83841",
        },
        {
            id: "Personas morales",
            label: "Personas morales",
            value: totalMorales,
            color: "#10477d",
        },
    ];

    const deudaData = empresasConDeuda.map((item) => ({
        nombre: item.name.length > 20 ? item.name.slice(0, 20) + "..." : item.name,
        fullName: item.name,
        deuda: Math.abs(item.balance),
    }));

    return (
        <div className="p-4">
            <div className="h-[50vh]">
                <ResponsivePie
                    data={pieData}
                    margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
                    innerRadius={0.5}
                    padAngle={0.7}
                    cornerRadius={3}
                    activeOuterRadiusOffset={8}
                    borderWidth={1}
                    borderColor={{ from: "color" }}
                    arcLinkLabelsSkipAngle={10}
                    arcLinkLabelsTextColor="#333333"
                    arcLinkLabelsThickness={2}
                    arcLinkLabelsColor="#4b596e22"
                    arcLabelsSkipAngle={10}
                    arcLabelsTextColor="#ffffff"
                    colors={(datum) => datum.data.color}
                />
            </div>

            <div className="w-full md:w-1/2 mx-auto mt-6">
                <div className="text-center font-semibold mb-1">Distribución de empresas</div>
                <div className="w-full bg-gray-200 rounded-full h-4 overflow-hidden">
                    <div
                        className="bg-red-500 h-4"
                        style={{ width: `${porcentajeNaturales}%` }}
                        title="Personas físicas"
                    ></div>
                </div>
                <div className="flex justify-between text-sm mt-1">
                    <span>Personas físicas ({porcentajeNaturales}%)</span>
                    <span>Personas morales ({porcentajeMorales}%)</span>
                </div>
            </div>

            <div className="w-full flex flex-col md:flex-row md:justify-around space-y-4 md:space-y-0 py-6">
                <StatCard title="Porcentaje de Personas físicas" value={`${porcentajeNaturales} %`} />
                <StatCard title="Porcentaje de personas morales" value={`${porcentajeMorales} %`} />
                <StatCard title="Total de empresas" value={totalEmpresas} />
            </div>
            {deudaData.length > 0 && (
                <div className="h-[45vh] mt-10">
                    <h3 className="text-center font-semibold mb-4">Deuda por Empresa</h3>
                    <ResponsiveBar
                        data={deudaData}
                        keys={["deuda"]}
                        indexBy="nombre"
                        margin={{ top: 40, right: 80, bottom: 100, left: 100 }}
                        padding={0.3}
                        layout="vertical"
                        colors={{ scheme: "reds" }}
                        axisBottom={{ tickRotation: -45 }}
                        labelSkipWidth={12}
                        labelSkipHeight={12}
                        labelTextColor="#fff"
                        tooltip={({ id, value, data }) => (
                            <div className="p-2 bg-white text-sm shadow rounded">
                                <strong>{data.fullName}</strong><br />
                                Deuda: ${value.toLocaleString()}
                            </div>
                            )}
                    />
                </div>
            )}
        </div>
    );
};

export default EmpresaListStats;
